// extracted by mini-css-extract-plugin
export default {"wrapper":"Qs-z","response":"Rs-z","error":"Ss-z","disabled":"Ts-z","buttons":"Us-z","feedbackQuestionSection":"Vs-z","yesNoWrapper":"Ws-z"};